<template>
  <div>
    <NavComponent :index="2"></NavComponent>
    <SideBarComponent></SideBarComponent>
    <div class="detail-top content-container">
      <div class="top-left">
        <!-- 轮播图 -->
        <Swiper
          class="swiper-container"
          :options="swiperOption"
          ref="swiperTop"
        >
          <Swiper-slide
            class="slid-container"
            v-for="(slideItem, index) in detail.picture.origin"
            :key="index"
          >
            <div class="slide" v-bind:style="{backgroundImage:'url(' + slideItem + ')'}">
                        </div>
            <!-- <img class="slide" :src="slideItem"  /> -->
          </Swiper-slide>
        </Swiper>
        <!-- 缩略图 -->
        <Swiper
          class="swiper gallery-thumbs"
          :options="swiperOptionThumbs"
          ref="swiperThumbs"
        >
          <Swiper-slide
            class="slid-container"
            v-for="(slideItem, index) in detail.picture.thumb"
            :key="index"
          >
            <!-- <div class="slide-thumbs" v-bind:style="{background:'url(' + slideItem + ') no-repeat center'}">
                        </div> -->
            <img class="slide-thumbs" :src="slideItem" />
          </Swiper-slide>
        </Swiper>
        <div class="vr-video">
            <div class="icon-button" v-if="detail.vr" @click.stop="openVr(detail.vr)"><img :src="vr_icon" /><span>VR</span></div>
            <!-- <div class="icon-button" ><img :src="video_icon" /><span>视频</span></div> -->
        </div>
      </div>
      <!-- 头部 -->
      <div class="top-right">
        <div class="title">
          <div class="aparment-title">{{ detail.houseno }}</div>
          <div class="title-right" @click="goProcedure()">
            <img class="icon-img2" :src="icon_img2" />租房流程
          </div>
        </div>
        <ul>
          <li v-for="(item, index) in detail.activity" :key="index">
            {{ item }}
          </li>
        </ul>
        <p>
          <span>房源类型：</span><i>{{ detail.housetype }}</i>
        </p>
        <p>
          <span>建筑： </span><i>{{ detail.architecture }}</i>
        </p>
        <p style="display:flex;">
          <span style="flex:0.5;">楼层：<i>{{ detail.floor }}</i></span>
          <span style="flex:0.5;">装修：<i>{{ detail.renovation }} </i></span>
        </p>
        <p style="display:flex;">
          <span style="flex:0.5;">卧室数量：<i>{{ detail.bedrooms }}</i></span>
          <span style="flex:0.5;">卫浴数量：<i>{{ detail.bathroom }}</i></span>
        </p>
        <p>
          <span>租金包含：</span><i>{{ detail.features }}</i>
        </p>
        <p>
          <span>地址：</span><i>{{ detail.address }} </i
          >
        </p>
        <div class="local" >
          <img class="icon-img" :src="local_icon" v-if="detail.college !== undefined && detail.college.length > 0" /><i
            v-for="item in detail.college"
            :key="item.id"
            >{{ item }}</i
          >
        </div>
        <div class="call-servier" @click="getService()">
          <img class="icon-service" :src="icon_service" />立即咨询专业顾问
        </div>
      </div>
    </div>

    <div v-if="servierBox" class="dialog-servier" @click="colseServier()">
      <div class="servier-item">
        <div class="servier-title">扫描二维码，咨询顾问及时解答您的订房问题</div>
        <div class="servier-code">
          <div class="code-item">
            <div>
              <img :src="cn_code" />
              <span>（中国）咨询顾问</span>
            </div>
            <div>
              <img :src="cn_code" />
              <span>（英国）咨询顾问</span>
            </div>
          </div>
          <div class="tel-item">
            <p>中国：+86 (0) 10 8418 5298</p>
            <p>英国：+44 (0) 74 2290 3801</p>
            <p>北京时间：9:00 - 18:00（节假日除外）</p>
          </div>
        </div>
      </div>
    </div>
    <div :class="[fixedTop ? 'barTab fixe-id' : 'barTab']" ref="barTab">
      <ul class="content-container">
        <div v-for="(item) in barName"
            :key="item.name">
          <li
            v-bind:class="[item.id == itemId ? 'li active' : 'li']"
            @click="changeClass(item.id)"
          >
            {{ item.name }}
          </li>
        </div>
      </ul>
    </div>
    <div class="content-container main" ref="house">
      <div>
        <div class="main-title"><span></span><i>房屋概况</i></div>
        <div class="house-type-title">
          <span class="span1">房间</span>
          <span class="span2">卫浴</span>
          <span class="span3">允许入住</span>
          <span class="span4">正课租期</span>
        </div>
        <div class="room-list">
          <div
            class="house-room"
            v-for="(item, index) in detail.bedroom"
            :key="index"
          >
            <div class="room-image" :style="{backgroundImage:'url(' + item.image + ')'}"></div>
            <div class="type-style">{{ item.roomtype }}</div>
            <div class="type-room">{{item.bathroom}}</div>
            <div class="room-number">{{item.in_cnt}} 人</div>
            <div class="tenancy-list">
              <div
                class="tenancy"
                v-for="(item, index) in item.tenancy"
                :key="index"
              >
                {{ item.lease_start }} 至 {{ item.lease_end }}
              </div>
            </div>
          </div>
        </div>
        <div v-html="detail.overview" class="aparment-detail-content"></div>
        <div class="detail-service">
          <div>详情请扫描以下二维码添加企业微信进行咨询</div>
          <img class="code" :src="service_code" />
          <div class="tips">注：由于网站信息更新或有延迟，所有平台标示价格、以及与房屋相关的各项信息均以英国线下工作人员确认为准，最终解释权归汉伦所有</div>
        </div>
      </div>
      <div>
        <div class="main-title"><span></span><i>配套设施</i></div>
        <div class="icon-list">
          <div v-for="(item,index) in iconList" :key="index">
            <div  class="icon" v-bind:style="{background:'url(' + item.icon + ') no-repeat center'}">
            </div>
            <div style="margin-bottom:1rem;">{{item.name}}</div>
          </div>
        </div>
        <!-- <div class="">
          <span>卧室：</span>
          <div v-for="(item,index) in iconList" :key="item.name+index" class="icon" v-bind:style="{background:'url(' + item.name + ') no-repeat center'}"></div>
          <div
            class="icon"
            v-for="(item, index) in iconList"
            :key="item.name + index"
          >
            <img :src="'../assets/image/detail-icon/' + item.name + '.png'" />
          </div>
        </div>
        <div>
          <span>厨房/客厅：</span>
        </div>
        <div>
          <span>其它：</span>
        </div>
        <div>
          <span>楼内：</span>
        </div> -->
      </div>
      <div>
        <div class="main-title"><span></span><i>周边环境</i></div>
        <div v-html="detail.conditions" class="aparment-detail-content"></div>
      </div>
      <div>
        <div class="main-title"><span></span><i>地理位置</i></div>
        <div id="map" class="detail-map"></div>
      </div>
      <div>
        <div class="main-title"><span></span><i>户型</i></div>
        <img class="layout" :src="detail.layout" />
      </div>
      <!-- <div>
        <div class="main-title"><span></span><i>能耗测评</i></div>
        <div v-html="detail.evaluation"></div>
      </div> -->
    </div>
    <!-- <div class="detail-bottom content-container">
            <div class="bottom-title"><span> 推 </span> / <span>荐</span> / <span>房</span> / <span>源</span></div>
            <div class="bottom-list">
                <AparmentListComponent v-for="(item,index) in 3" :key="index+100"></AparmentListComponent>
            </div>
        </div> -->
    <FooterComponent></FooterComponent>
  </div>
</template>
<script>
import FooterComponent from "@components/FooterComponent";
import NavComponent from "@components/NavComponent";
import SideBarComponent from "@components/SideBarComponent";
// import AparmentListComponent from '@components/AparmentListComponent'
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

import icon_service from "@assets/image/rent/icno-1.png";
import local_icon from "@assets/image/rent/local-icon.png";
import icon_img2 from "@assets/image/rent/icon-2.png";
import cn_code from "@assets/image/rent/cn_qrcode_1.jpg";
import en_code from "@assets/image/rent/england_qrcode_1.jpg";
import mapboxgl from "mapbox-gl"

import vr_icon from '@assets/image/rent/vr_icon.png'

import wifi_icon  from '@assets/image/furniture-icon/wifi_icon.png'
import bank_icon from '@assets/image/furniture-icon/bank_icon.png'
import bingxiang_icon from '@assets/image/furniture-icon/bingxiang_icon.png'
import daocha_icon from '@assets/image/furniture-icon/daocha_icon.png'
import nuanqi_icon from '@assets/image/furniture-icon/nuanqi_icon.png'
import internet_icon from '@assets/image/furniture-icon/internet_icon.png'
import shafa_icon from '@assets/image/furniture-icon/shafa_icon.png'
import xiyiji_icon from '@assets/image/furniture-icon/xiyiji_icon.png'
import luzao_icon from '@assets/image/furniture-icon/luzao_icon.png'
import shaokaoxiang_icon from '@assets/image/furniture-icon/shaokaoxiang_icon.png'
import yigui_icon from '@assets/image/furniture-icon/yigui_icon.png'
import shopping_icon from '@assets/image/furniture-icon/shopping_icon.png'
import menjin_icon from '@assets/image/furniture-icon/menjin_icon.png'
import table_icon from '@assets/image/furniture-icon/table_icon.png'
import tv_icon from '@assets/image/furniture-icon/tv_icon.png'
import parking_icon from '@assets/image/furniture-icon/parking_icon.png'
import jianshenfang_icon from '@assets/image/furniture-icon/jianshenfang_icon.png'
import chongwu_icon from '@assets/image/furniture-icon/chongwu_icon.png'
import gongyuan_icon from '@assets/image/furniture-icon/gongyuan_icon.png'
import microwave_oven_icon from '@assets/image/furniture-icon/microwave_oven_icon.png'
import dianti_icon from '@assets/image/furniture-icon/dianti_icon.png'
import xiwanji_icon from '@assets/image/furniture-icon/xiwanji_icon.png'
import chaji_icon from '@assets/image/furniture-icon/chaji_icon.png'
import bread_machine_icon from '@assets/image/furniture-icon/bread_machine_icon.png'
import water_dispenser_icon from '@assets/image/furniture-icon/water_dispenser_icon.png'

import service_code from '@assets/image/rent/two-code.jpg'
import bed_icon from "@assets/image/detail-icon/bed.png";

export default {
  name: "MoveHousePage",
  computed: {},
  components: {
    FooterComponent,
    NavComponent,
    SideBarComponent,
    // AparmentListComponent,
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      icon_service,local_icon,icon_img2,bed_icon,cn_code,en_code,service_code,vr_icon,
      loaclList:{
        'wifi_icon':wifi_icon,'bank_icon':bank_icon,'bingxiang_icon':bingxiang_icon,'daocha_icon':daocha_icon,'nuanqi_icon':nuanqi_icon,
        'internet_icon':internet_icon,'shafa_icon':shafa_icon,'xiyiji_icon':xiyiji_icon,'luzao_icon':luzao_icon,'shaokaoxiang_icon':shaokaoxiang_icon,
        'yigui_icon':yigui_icon,'shopping_icon':shopping_icon,'menjin_icon':menjin_icon,'table_icon':table_icon,'tv_icon':tv_icon,
        'jianshenfang_icon':jianshenfang_icon,'chongwu_icon':chongwu_icon,'gongyuan_icon':gongyuan_icon,'microwave_oven_icon':microwave_oven_icon,'dianti_icon':dianti_icon,
        'xiwanji_icon':xiwanji_icon,'chaji_icon':chaji_icon,'bread_machine_icon':bread_machine_icon,'water_dispenser_icon':water_dispenser_icon,'parking_icon':parking_icon
      },
      iconList: [],
      servierBox:false,
      detail: {
        picture: {},
      },
      itemId:0,
      fixedTop:false,
      barName: [
        { name: "房屋概况",id:0 },
        { name: "配套设施" ,id:1},
        { name: "周边环境" ,id:2},
        { name: "地理位置" ,id:3},
        { name: "户型" ,id:4},
        // { name: "能耗测评" ,id:5},
      ],
      swiperOption: {
        loop: true,
        loopedSlides: 4,
        spaceBetween: 10,
        autoplay: {
          //自动播放
          delay: 5000,
        },
      },
      swiperOptionThumbs: {
        loop: true,
        loopedSlides: 4, // looped slides should be the same
        spaceBetween: 10,
        // centeredSlides: true,
        slidesPerView: "auto",
        touchRatio: 0.2,
        slideToClickedSlide: true,
      },
    };
  },
  created(){
    //获取页面数据
    this.getAparmentDetail(this.$route.query.id);
  },
  mounted() {
    this.$nextTick(() => {
      const swiperTop = this.$refs.swiperTop.$swiper;
      const swiperThumbs = this.$refs.swiperThumbs.$swiper;
      swiperTop.controller.control = swiperThumbs;
      swiperThumbs.controller.control = swiperTop;
    });
    //监听滚动条变化
    window.addEventListener('scroll',this.handleScrollx,true)
  },
  methods: {
    changeClass(id) {
      this.itemId = id;
      window.scrollTo({
        behavior: "smooth",
        top: this.$refs.house.children[id].offsetTop-64,
      });
    },
    //滚动条吸顶
    handleScrollx() {
      let height = this.$refs.barTab.getBoundingClientRect().top;

      if(height <= 5){
        this.fixedTop = true;
      }
      if(window.pageYOffset < 800){
        this.fixedTop = false;
      }
    },
    //地图初始化
    getMap() {
        let that = this
        let center = [this.detail.longitude,this.detail.latitude]
        mapboxgl.accessToken =
            "pk.eyJ1IjoidXppbGl2aW5nIiwiYSI6ImNqemhzbmdxMTB5Y3MzZHBpazN1N3d2cTkifQ.3-_OtVv-450QSH1sNu2mGA";
        var map = new mapboxgl.Map({
            container: "map",
            style: "mapbox://styles/mapbox/streets-v11?optimize=true",
            center: center,
            pitch: 60,
            bearing: -60,
            zoom: 16,
        });
        new mapboxgl.Popup({ closeButton: false, offset: 25 })
            .setLngLat(center)
            .setHTML("<h1>" + that.detail.houseno + "</h1>")
            .addTo(map);
        new mapboxgl.Marker().setLngLat(center).addTo(map);
    },
    goProcedure() {
      this.$router.push("/procedure");
    },
    getAparmentDetail(id) {
      var that = this;
      this.axios
        .post(this.url + "/api/house/detail", { id: id })
        .then(function (res) {
          that.detail = res.data.data;
          // that.banner = res.data.data.picture.origin.slice(0,1)
          console.log(that.banner,'0000')
          that.iconList = that.detail.facilities.map((item)=>{
              item.icon = that.loaclList[item.icon]
              return item
          })
          console.log(that.iconList)
          that.getMap()
        })
        .catch(function () {});
    },
    getService(){
      this.servierBox = true;
    },
    colseServier(){
      this.servierBox = false;
    },
    //跳转vr链接
    openVr(url){
      window.open(url,'_blank')
    }

  },
  //移除监听事件
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScrollx, true)
  }
};
</script>
<style lang="scss" scoped>
.detail-top {
  display: flex;
  padding: 1.1rem 0 4rem;
}
.top-left {
  width: 30rem;
  position: relative;
  overflow: hidden;
  flex: 0 0 auto;
  .gallery-top {
    height: 80%;
    width: 100%;
  }
  .gallery-thumbs {
    height: 20%;
    box-sizing: border-box;
    // padding: $gap 0;
  }
  .gallery-thumbs .swiper-slide {
    width: 25%;
    height: 100%;
    opacity: 0.4;
  }
  .gallery-thumbs .swiper-slide-active {
    opacity: 1;
  }
  .slide {
    width: 30rem;
    height: 20rem;
    background-size: cover;
    background-position-x: center;
    background-position-y: 0;
    background-repeat: no-repeat;
  }
  .slide[lazy=loading] {
    background: #eee;
   }
  .slide-thumbs {
    width: 100%;
    height: 4.8rem;
    margin-top: 0.5rem;
  }
  .vr-video{
    position: absolute;
    display: flex;
    cursor: pointer;
    z-index:9999;
    top: 1rem;
    left: 1rem;
    color: #fff;
    font-size: 0.7rem;
    .icon-button{
      width: 3.8rem;
      height: 1.5rem;
      line-height: 1.5rem;
      background-color:rgba(14, 45, 87,0.5);
      border-radius: 6px;
      margin-right:0.5rem;
      align-items: center;
      display: flex;
      img{
          width: 0.9rem;
          height: 0.9rem;
          display: block;
          margin: 0 0.5rem;
      }
    }
  }
}
.top-right {
  padding-left: 3.5rem;
  width: 26rem;
  .title {
    display: flex;
    justify-content: space-between;
    border-bottom: solid 1px #d8d8d8;
  }
  .title-right {
    color: #a22915;
    font-size: 1rem;
    line-height: 2.8rem;
    cursor: pointer;
    .icon-img2 {
      width: 1rem;
      height: 1.1rem;
      margin-right: 0.4rem;
      margin-bottom: 0.3rem;
    }
  }
  .aparment-title {
    font-size: 1.6rem;
    font-weight: 700;
    line-height: 2.8rem;
    color: #0e2d57;
  }
  ul {
    display: flex;
    flex-wrap: wrap;
    margin-top: 0.5rem;
    min-height: 3rem;
    li {
      height: 1.5rem;
      background-color: #d7e0ec;
      border-radius: 4px;
      border: solid 1px #0e2d57;
      color: #3a4a5b;
      font-size: 1rem;
      line-height: 1.5rem;
      padding: 0 0.8rem;
      margin: 0.5rem 0.6rem 0.5rem 0;
    }
  }
  p:not(:last-child) {
    margin-bottom: 0.6rem;
  }
  span {
    font-size: 1rem;
    font-weight: 700;
    color: #3a4a5b;
  }
  i {
    font-size: 1rem;
    font-weight: normal;
    color: #3a4a5b;
  }
  .margin-right {
    margin-left: 2rem;
  }
  .local {
    margin-top: 1rem;
    padding-bottom: 0.4rem;
    border-bottom: solid 1px #d8d8d8;
    color: #3a4a5b;
    i {
      margin-left: 0.9rem;
      font-size: 1rem;
    }
    .icon-img {
      width: 1.8rem;
      height: 1.4rem;
    }
  }
  .call-servier {
    width: 14rem;
    height: 2.3rem;
    background-color: #0e2d57;
    color: #fff;
    text-align: center;
    line-height: 2.3rem;
    margin-top: 1rem;
    cursor: pointer;
  }
  .icon-service {
    width: 1.6rem;
    height: 1.4rem;
    margin-right: 0.8rem;
    margin-bottom: 0.2rem;
  }
}
.dialog-servier{
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  font-size: 0.8rem;
  z-index: 999999;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: rgba($color: #000000, $alpha: 0.5);
  .servier-item{
    width: 20em;
    height: auto;
    background-color: #fff;
    padding: 1rem;
    box-sizing: content-box;
    margin: 0 auto;
    .servier-title{
      color: #c8a063;
      text-align: center;
    }
    .code-item{
      margin-top: 1rem;
      display: flex;
      justify-content:space-around;
      span{
        display: block;
        text-align: center;
        font-size: 0.6rem;
        line-height: 1rem;
      }
    }
    img{
      width: 6rem;
      height: 6rem;
      display: block;
    }
  }
  .tel-item{
    margin-top: 1.5rem;
    p{
      line-height: 1.2rem;
    }
  }
}

.barTab {
  width: 100%;
  height: 3.2rem;
  background-color: #0e2d57;
  cursor: pointer;
  ul {
    display: flex;
    text-align: center;
    .li {
      width: 8.7rem;
      height: 3.2rem;
      line-height: 3.2rem;
      color: #fff;
    }
    .active {
      background-color: #e8eef6;
      color: #0e2d57;
    }
  }
}
.fixe-id{
  // position: fixed;
  // top: 0;
  z-index: 9999;
  position: sticky;
  top: -1px;
}

.main {
  padding-bottom: 3rem;
  .main-title {
    padding: 2.5rem 0 1.5rem;
    font-size: 1.2rem;
    color: $font;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    span {
      display: inline-block;
      width: 0.3rem;
      height: 1.1rem;
      margin-right: 0.6rem;
      background: #a22915;
    }
  }
  .icon-list{
    text-align: center;
    font-size: 0.8rem;
    line-height: 1.6rem;
    display: flex;
    flex-wrap: wrap;
  }
  .house-type-title {
    height: 2.1rem;
    color: $font;
    line-height: 2rem;
    text-align: center;
    font-size: 1rem;
    background-color: #d7e0ec;
    span {
      display: inline-block;
    }
    .span1{
      width: 21rem;
    }
    .span2{
      width: 11.5rem
    }
    .span3{
      width: 7.5rem;
    }
    .span4{
      width: 19.3rem;
    }
  }
  .layout {
    max-width: 16rem;
    height: auto;
  }
}
.detail-map{
  width: 100%;
  height: 30rem;
}
.detail-bottom {
  padding-bottom: 5rem;
}
.bottom-title {
  text-align: center;
  line-height: 6rem;
  span {
    display: inline-block;
    font-size: 1.3rem;
    font-weight: 700;
    line-height: 1.8rem;
    letter-spacing: 1px;
    text-align: center;
    color: #0e2d57;
  }
}
.bottom-list {
  display: flex;
  justify-content: space-between;
}
.room-list {
  background-color: #fcfcfc;
  border: solid 1px #f5f5f5;
  padding: 0 0 1.1rem 0.8rem;
  margin-bottom: 2rem;
}
.house-room {
  padding-top: 0.5rem;
  display: flex;
  line-height: 5rem;
  color: $font;
  font-size: 0.8rem;
  text-align: center;
  .type-style {
    width: 13rem;
    border-right: solid 1px #d8d8d8;
  }
  .type-room {
    width: 11.5rem;
  }
  .room-image {
    width: 7.5rem;
    height: 5rem;
    background-repeat: no-repeat;
    background-position: center;
    background-size:100% 100%;
  }
  .room-number {
    width: 7.5rem;
  }
}
.tenancy-list {
  text-align: center;
  height: 5rem;
  padding-top: 1rem;
  width: 19.3rem;
  box-sizing: border-box;
  .tenancy {
    line-height: 1.5rem;
  }
}
.icon {
  width: 5rem;
  height: 2.4rem;
}
.detail-service{
  font-size: 0.7rem;
  img{
    width:10rem;
    margin-top: 1rem;
    height: auto;
  }
  .tips{
    color: #a22915;
    margin-top: 1rem;
  }
}
@media only screen and (max-width: 1024px){
  .top-left {
    width: 100%;
    .slide {
      width: 100%;
      height: 20rem;
    }
    .gallery-thumbs{
      width: 100%;
      height: 6rem;
    }
  }
  .top-right{
    width: 94%;
    margin: 0 auto;
    padding-left: 0;
  }
  .barTab{
    display: none;
  }
  .detail-top {
    width: 100%;
    display: block;
    padding: 0;
  }
  .detail-map{
    width: 100%;
    height: 20rem;
  }
  .main{
    width: 94%;
    margin: 0 auto;
    .main-title{
      padding: 1.5rem 0 1.5rem;
    }
    .house-type-title{
      .span1{
        width: 12rem;
      }
      .span2{
        width: 6rem
      }
      .span3{
        width: 7.5rem;
      }
      .span4{
        width: 8rem;
      }
    }
  }
}
</style>
<style lang="scss">
.main{
  .aparment-detail-content{
    color: $font!important;
    font-size: 0.9rem!important;
    line-height: 1.6rem!important;
  }
}
</style>